import React, { useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import toast from "react-hot-toast";

const SelectIndustry = ({ formData, setFormData, error }) => {
    const [validated, setValidated] = useState(false);
    const [otherIndustry, setOtherIndustry] = useState('');

    const industries = [
        "Agriculture", "Automotive", "Chemical", "Construction",
        "Education", "Energy", "Financial", "Jewellery",
        "Fintech", "Pharmaceutical", "Healthcare", "Manufacturing",
        "Oil and Gas", "Technology", "Food and Beverage",
        "Mining", "Software", "Hardware", "Logistics",
        "Retail & Wholesale", "Transportation", "Real Estate",
        "Defense", "Petroleum", "Telecommunications",
        "Aerospace", "Biotechnology", "Fabric", "Media",
        "Information Technology", "Toys", "Ceramics",
    ].sort();

    const handleIndustryChange = (industry) => {
        setValidated(false);

        setFormData((prevFormData) => {
            const currentIndustries = prevFormData.industries;
            const isSelected = currentIndustries.includes(industry);

            // If trying to add a new industry
            if (!isSelected) {
                // Check if adding would exceed the limit (excluding "Other")
                const nonOtherCount = currentIndustries.filter(ind => ind !== "Other").length;
                if (nonOtherCount >= 6 && industry !== "Other") {
                    toast.error('You can select a maximum of 6 industries');
                    return prevFormData;
                }
            }

            // Handle removal of "Other" - also clear other industries
            if (isSelected && industry === "Other") {
                return {
                    ...prevFormData,
                    industries: currentIndustries.filter(i => i !== industry),
                };
            }

            // Regular add/remove
            return {
                ...prevFormData,
                industries: isSelected
                    ? currentIndustries.filter(i => i !== industry)
                    : [...currentIndustries, industry]
            };
        });
    };

    const handleOtherIndustryAdd = (e) => {
        e.preventDefault();
        if (!otherIndustry.trim()) {
            return;
        }

        // Check if the industry name already exists
        if (formData.industries.includes(otherIndustry.trim())) {
            toast.error('This industry has already been added');
            return;
        }

        // Check max limit for other industries (3)
        if (formData.industries.length >= 9) { // 6 main + 3 other
            toast.error('You can add a maximum of 6 industries and 3 other industries');
            return;
        }

        setFormData(prevFormData => ({
            ...prevFormData,
            industries: [...prevFormData.industries, otherIndustry.trim()]
        }));
        setOtherIndustry('');
    };

    const removeOtherIndustry = (indexToRemove) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            industries: prevFormData.industries.filter((_, index) => index !== indexToRemove)
        }));
    };

    const getSelectedCount = () => {
        return formData.industries.filter(industry => industry !== "Other").length;
    };

    return (
        <Form noValidate validated={validated}>
            <h5 className="fw-bold">Select Your Industry <span className="text-danger fw-bold">*</span></h5>
            <div className='text-xs text-danger fw-bold' style={{ fontSize: '0.9rem' }}>
                <span className="text-danger ">*</span> Here, you can select up to 6 industries for which you can offer guidance based on your knowledge and experience.
            </div>
            <hr />

            <div className="mb-2 fw-semibold">
                Selected: {getSelectedCount()}/6 industries
            </div>

            <Form.Group className="mb-3">
                <div className={`mb-3 ${validated && formData.industries.length === 0 ? "is-invalid" : ""}`}>
                    <Row xs={2} md={3} lg={4} className="g-3">
                        {[...industries, "Other"].map((industry) => (
                            <Col key={industry}>
                                <Card
                                    className={`cursor-pointer ${formData.industries.includes(industry)
                                        ? "bg-primary text-white"
                                        : "bg-light"
                                        }`}
                                    onClick={() => handleIndustryChange(industry)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <Card.Body className="p-1 text-center">
                                        {industry}
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Form.Group>

            {formData.industries.includes("Other") && (
                <Form.Group className="mb-3">
                    <Form.Label className='fs-6 fw-bold'>Specify Other Industries (Max 3)</Form.Label>
                    <div className="d-flex gap-2 mb-2">
                        <Form.Control
                            type="text"
                            value={otherIndustry}
                            onChange={(e) => setOtherIndustry(e.target.value)}
                            placeholder="Enter industry name"
                            maxLength={30}
                        />
                        <button
                            className="btn btn-primary"
                            onClick={handleOtherIndustryAdd}
                            disabled={!otherIndustry.trim()}
                        >
                            Add
                        </button>
                    </div>

                    {formData.industries.filter(ind => ind !== "Other").length > 0 && (
                        <div className="mt-3">
                            <div className="fw-bold mb-2">Added Other Industries:</div>
                            {formData.industries.filter(ind => ind !== "Other").map((industry, index) => (
                                <div
                                    key={index}
                                    className="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded"
                                >
                                    <span>{industry}</span>
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeOtherIndustry(index)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </Form.Group>
            )}
            <hr />
        </Form>
    );
};

export default SelectIndustry;